import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import Icon from "components/library/Icon";
import KeepReadingEditor from "editor/components/KeepReadingEditor";
import calculateReadingTime from "editor/utils/calculateReadingTime";
import calculateWordCount from "editor/utils/calculateWordCount";
import getActiveEditorState from "editor/utils/getActiveEditorState";
import styles from "./KeepReading.css";

class KeepReading extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      element: null,
    };
    this.activate = this._activate.bind(this);
    this.deactivate = this._deactivate.bind(this);
  }

  _activate() {
    this.setState({ isActive: true });

    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur(); // Remove focus from the editor.
    }
  }

  _deactivate() {
    this.setState({ isActive: false });
  }

  render() {
    const buttonText = this.props.block.getData().get("buttonText");
    const showWordCount = this.props.block.getData().get("showWordCount");
    const readingTime = calculateReadingTime(
      calculateWordCount(this.props.editorState)
    );

    return (
      <div contentEditable={false}>
        <KeepReadingEditor
          onModalClose={this.deactivate}
          element={this.state.element}
          isActive={this.state.isActive}
          block={this.props.block}
          showWordCount={showWordCount}
          buttonText={buttonText}
        />
        <div
          className={styles.root}
          onClick={this.activate}
          ref={element => {
            if (!this.state.element) {
              this.setState({ element: element });
            }
          }}
        >
          {" "}
          {`${buttonText} (${readingTime} min. read)`}
          <Icon className={styles.arrow} name="go-deeper-arrow" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    editorState: getActiveEditorState(state),
  };
};

export default connect(
  mapStateToProps,
  null
)(KeepReading);

KeepReading.propTypes = {
  block: PropTypes.object.isRequired,
  editorState: PropTypes.object,
};
